import React, { useState } from "react";
import { ApolloClient, ApolloProvider, InMemoryCache } from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";
import { BrowserRouter as Router } from "react-router-dom";
import { GlobalContext } from "./context/GlobalContext";
import { setContext } from "@apollo/client/link/context";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AppRoutes from "./components/routes";
import GlobalStyles from "./styles/GlobalStyles";

function App() {
  const [token, setToken] = useState(null);
  const [rol, setRol] = useState(null);
  const [user, setUser] = useState(null);
  const [codeForgotPassword, setCodeForgotPassword] = useState(null);

  const uploadLink = createUploadLink({
    // eslint-disable-next-line
    uri: process.env.REACT_APP_ENDPOINT,
  });

  const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : "",
      },
    };
  });

  // Configuración del Apollo Client
  const client = new ApolloClient({
    link: authLink.concat(uploadLink),
    cache: new InMemoryCache(),
  });

  return (
    <GlobalContext.Provider
      value={{ token, setToken, rol, setRol, user, setUser, codeForgotPassword, setCodeForgotPassword }}
    >
      <ApolloProvider client={client}>
        <GlobalStyles />
        <Router>
          <AppRoutes />
        </Router>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </ApolloProvider>
    </GlobalContext.Provider>
  );
}

export default App;
